export const pageHeaderContainerDonateTextByLocale: Record<UserLocale, string> =
  {
    en: 'Donate',
    pt: 'Doar',
    es: 'Haz una Donación',
  };
